import { createSlice } from '@reduxjs/toolkit';

const companySlice = createSlice({
  name: 'companies',
  initialState: {
    companies: [],
    currentCompany: null,
    myCompanies: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    setCompanies: (state, action) => { state.companies = action.payload; },
    setCurrentCompany: (state, action) => { state.currentCompany = action.payload; },
    setMyCompanies: (state, action) => { state.myCompanies = action.payload; },
    setLoading: (state, action) => { state.isLoading = action.payload; },
    setError: (state, action) => { state.error = action.payload; },
    clearError: (state) => { state.error = null; },
  },
});

export const { setCompanies, setCurrentCompany, setMyCompanies, setLoading, setError, clearError } = companySlice.actions;
export default companySlice.reducer;
